import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  apiUrl: string = environment.apiUrl;
  menuOpen: boolean = false;

  modalGaleriaSubject = new Subject<boolean>();

  constructor() { }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

}
